// removed by extract-text-webpack-plugin
module.exports = {"currency":"src-components-Currency-___index__currency___2wjPU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Currency/index.css
// module id = 852
// module chunks = 3